import { StyledDeleteChatModal } from './DeleteChatModal.style';
import Button from '../../Button';
import sessionsService from '../../../services/sessionsServices';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Toast from '../../Toast';

const DeleteChatModal = ({ onClose, data }) => {
  const queryClient = useQueryClient();

  const handleSubmit = useMutation({
    mutationFn: async () => {
      return await sessionsService?.deleteSession({
        platform_id: 'feedalabs',
        session_id: data?.id,
        user_id: '123',
        agent_id: 'ferdy',
        project_id: 'test',
      });
    },
    retry: 1,
    onSuccess: response => {
      Toast({
        type: 'success',
        message: response.detail,
      });
      onClose();
      queryClient.invalidateQueries({ queryKey: ['sessions'] });
    },
    onError: err => {
      Toast({
        type: 'error',
        message: err.detail,
      });
    },
  });

  return (
    <StyledDeleteChatModal>
      <h2 className="desc">Are you sure you want to delete this chat? There is no way to recover it.</h2>
      <div className="btn-holder">
        <Button width="102px" variant="secondary-outline" onClick={() => onClose()}>
          No
        </Button>
        <Button width="108px" onClick={() => handleSubmit.mutate()} loader={handleSubmit?.isPending}>
          Yes
        </Button>
      </div>
    </StyledDeleteChatModal>
  );
};

export default DeleteChatModal;
